import { Button, ButtonProps } from '@mui/material'

import GoogleMark from './GoogleMark'

// ----------------------------------------------------------------------
// Continue with Google, drawn the way Google asks its sign-in button to be
// drawn: its own fill, edge and ink in each scheme, and its G in its own
// colours at the start. All four colours are Google's (`googleButton` in the
// palette, from the tokens), so nothing here states one.
// ----------------------------------------------------------------------

export default function GoogleSignInButton({
  children = 'Continue with Google',
  sx,
  ...other
}: Omit<ButtonProps, 'color' | 'variant' | 'startIcon'>) {
  return (
    <Button
      variant="outlined"
      startIcon={<GoogleMark />}
      sx={[
        {
          'bgcolor': 'googleButton.fill',
          'color': 'googleButton.text',
          'borderColor': 'googleButton.edge',
          '&:hover': {
            bgcolor: 'googleButton.pressed',
            borderColor: 'googleButton.edge',
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {children}
    </Button>
  )
}
